import { type Identity } from 'shared/types'

import { type Assessment, type AssessmentStatus } from './entities/KYC'

const PENDING_ASSESSMENT_STATUSES: AssessmentStatus[] = ['requested', 'partially_rejected']

function findAssessmentByReason(
  reason: Assessment['reason'],
  userAssessment?: Assessment,
  organizationAssessments?: Assessment[]
) {
  const notNullableOrgAssessments = organizationAssessments || []
  return [userAssessment, ...notNullableOrgAssessments].find(assessment => assessment?.reason === reason)
}

function findCurrentAssessment(options: {
  identity: Identity
  userAssessment?: Assessment
  organizationAssessments?: Assessment[]
}) {
  const { identity, userAssessment, organizationAssessments } = options

  const orgId = options.identity.id.split(':')[1]

  if (identity.id.includes('user')) return userAssessment

  if (userAssessment) return userAssessment

  return organizationAssessments?.find(item => item.organizationId === orgId)
}

function findPendingOrganizationAssessment(
  reason: Assessment['reason'],
  entityId: string,
  organizationAssessments?: Assessment[]
) {
  const [type, organizationId] = entityId.split(':')

  if (type !== 'organization') return undefined

  return organizationAssessments?.find(
    assessment =>
      assessment.reason === reason &&
      assessment.organizationId === organizationId &&
      PENDING_ASSESSMENT_STATUSES.includes(assessment.status)
  )
}

export const kycAssessment = { findCurrentAssessment, findAssessmentByReason, findPendingOrganizationAssessment }
